import React from 'react';
import { compose, withApollo } from 'react-apollo';
import { Button, Dropdown, Grid, Menu, Segment } from 'semantic-ui-react';
import AssigneeDropdown from '../../dropdowns/AssigneeDropdown';
import TaskButton from '../../TaskButton';
import withTaskPrioritiesOptions from '../../TasksListComponents/withTaskPrioritiesOptions';
import withTaskStateOptions from '../../TasksListComponents/withTaskStatesOptions';

const ManageMenu = ({
  values,
  taskStateOptions,
  taskPrioritiesOptions,
  prioritiesLoading,
  statesLoading,
  onChange,
  onClear,
  onApply,
  number,
}) => {
  const loading = statesLoading || prioritiesLoading;

  return (
    <Segment basic loading={loading}>
      <Menu.Item>
        <TaskButton />
      </Menu.Item>
      <Menu.Item>
        <Menu.Header>
          <Grid>
            <Grid.Row>
              <Grid.Column width={6} verticalAlign="middle">
                {number === 1 ? '1 task' : number + ' tasks'}
              </Grid.Column>
              <Grid.Column width={10} textAlign="right">
                <Button basic size="mini" color="red" onClick={onClear}>
                  Clear Changes
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Menu.Header>
        <Menu.Menu>
          <Menu.Item>Assign to</Menu.Item>
          <Menu.Item>
            <AssigneeDropdown name="userId" value={values.userId} onChange={onChange} />
          </Menu.Item>
          <Menu.Item>Change priority</Menu.Item>
          <Menu.Item>
            <Dropdown
              fluid
              name="priority"
              onChange={onChange}
              options={taskPrioritiesOptions}
              selection
              value={values.priority}
            />
          </Menu.Item>
          <Menu.Item>Change claim status</Menu.Item>
          <Menu.Item>
            <Dropdown fluid name="cStatus" search selection options={[]} disabled />
          </Menu.Item>
          <Menu.Item>Change task status</Menu.Item>
          <Menu.Item>
            <Dropdown
              fluid
              name="status"
              onChange={onChange}
              options={taskStateOptions}
              selection
              value={values.status}
            />
          </Menu.Item>
          <Menu.Item style={{ textAlign: 'center' }}>
            <Button primary onClick={onApply}>
              Apply
            </Button>
          </Menu.Item>
        </Menu.Menu>
      </Menu.Item>
    </Segment>
  );
};

const ManageMenuWithData = compose(
  withApollo,
  withTaskStateOptions,
  withTaskPrioritiesOptions
)(ManageMenu);

export default ManageMenuWithData;



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/ManageMenu/View.js